module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "task-preview"
    }
  }, [_c('div', {
    staticClass: "notification is-info has-text-centered on-top"
  }, [_c('div', {
    staticClass: "columns"
  }, [(_vm.task.syllab.language) ? _c('div', {
    staticClass: "column"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_syllab_word']))]) : _vm._e(), (_vm.task.syllab.language) ? _c('div', {
    staticClass: "column"
  }, [_c('button', {
    staticClass: "button is-primary is-small",
    on: {
      "click": _vm.syllabifyAll
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_syllab_all']))])]) : _vm._e(), (_vm.task.speech.language) ? _c('div', {
    staticClass: "column"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_speak_word']))]) : _vm._e()])]), _c('task-text', {
    ref: "container",
    nativeOn: {
      "click": [function($event) {
        if (!$event.ctrlKey) { return null; }
        _vm.syllabify($event)
      }, function($event) {
        if (!$event.altKey) { return null; }
        _vm.pronounce($event)
      }, function($event) {
        _vm.fixate($event)
      }]
    }
  }), _c('task-images', {
    attrs: {
      "images": _vm.images,
      "fixation": _vm.fixation
    }
  }), _c('div', {
    staticClass: "columns at-bottom"
  }, [_c('div', {
    staticClass: "column has-text-right"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.hasPrevPage
    },
    on: {
      "click": _vm.prev
    }
  }, [_c('span', [_vm._v("<")])])]), _c('div', {
    staticClass: "column has-text-centered is-narrow"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.close
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tokens['btn_close']))])])]), _c('div', {
    staticClass: "column has-text-left"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.hasNextPage
    },
    on: {
      "click": _vm.next
    }
  }, [_c('span', [_vm._v(">")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b6ac658"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/taskPreview.vue
// module id = 414
// module chunks = 0